import React from "react";
import cls from "./styles.module.scss";

type ButtonVariant = "primary" | "secondary";
type ButtonSize = "md" | "lg";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

export function Button({
  variant = "secondary",
  size = "md",
  fullWidth = true,
  leftIcon,
  rightIcon,
  className,
  children,
  type = "button",
  ...rest
}: ButtonProps) {
  const classes = [
    cls.button,
    cls[`variant_${variant}`],
    cls[`size_${size}`],
    fullWidth ? cls.fullWidth : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button type={type} className={classes} {...rest}>
      {leftIcon ? <span className={cls.iconLeft}>{leftIcon}</span> : null}
      <span className={cls.label}>{children}</span>
      {rightIcon ? <span className={cls.iconRight}>{rightIcon}</span> : null}
    </button>
  );
}
